import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { TNil } from '@app/app.interface';
import { HasPermissionDirective } from '@core/directives/has-permission.directive';
import { EPermissions } from '@enums/permissions.enum';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '@shared/components/base.component';
import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  imports: [MatButtonModule, TranslateModule, HasPermissionDirective, IconComponent],
  selector: 'app-create-entity-button',
  templateUrl: './create-entity-button.component.html',
})
export class CreateEntityButtonComponent extends BaseComponent {
  public readonly labelKey = input.required<string>();
  public readonly color = input<'primary' | 'secondary'>('primary');
  public readonly redirectUrl = input<string[] | TNil>(null);
  public readonly onClick = input<(() => void) | TNil>(null);

  public readonly permissions = input<EPermissions[]>([]);

  private readonly router = inject(Router);

  public onCreateClick(): void {
    if (this.redirectUrl()) {
      this.router.navigate(this.redirectUrl()!);
    }

    const callback: (() => void) | TNil = this.onClick() ?? null;

    if (callback) {
      callback();
    }
  }
}
